import { ref } from 'vue'
import { defineStore } from 'pinia'
import {
  useUnauthenticatedPost,
  useAuthenticatedDelete,
  useUnauthenticatedPut
} from '@/composables/request.js'

const TOKEN = 'token'
const TOKEN_EXPIRES_AT = 'token_expires_at'

export const useUserStore = defineStore('user', () => {
  const token = ref(getLocalToken())

  async function logIn(email, password) {
    const response = await useUnauthenticatedPost('/login', { legacy_life_concierge: { email, password }}, (error) => { console.log(error)})
    if (response.status === 200) {
      token.value = response.headers.authorization
      localStorage.setItem(TOKEN, token.value)
      localStorage.setItem(TOKEN_EXPIRES_AT, response.data.expires_at)
    }
    return response
  }

  async function logOut() {
    const response = await useAuthenticatedDelete('/logout')
    if (response.status === 200) {
      token.value = null
      localStorage.removeItem(TOKEN)
      localStorage.removeItem(TOKEN_EXPIRES_AT)
      sessionStorage.clear()
    } else {
      console.log(response.data)
    }
  }

  async function requestPasswordReset(email) {
    const response = await useUnauthenticatedPost("/password", {
      legacy_life_concierge: { email },
    });
    return response;
  }

  async function resetPassword(resetToken, password, passwordConfirmation) {
    const response = await useUnauthenticatedPut("/password", {
      reset_password_token: resetToken,
      password,
      password_confirmation: passwordConfirmation,
    });
    return response;
  }

  function getLocalToken() {
    if (localStorage.getItem(TOKEN)) {
      return localStorage.getItem(TOKEN)
    }
  }

  function tokenValid() {
    return parseInt(localStorage.getItem(TOKEN_EXPIRES_AT)) > Math.floor(new Date().getTime()) / 1000
  }

  function isAuthenticated() {
    return (token.value != null && tokenValid())
  }

  return { logOut, logIn, token, isAuthenticated, requestPasswordReset, resetPassword }
})
